export default __webpack_public_path__ + "b4b03e1694253d32544194a5b77f3632.png";